import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PageDetail from './pages/PageDetail';
import Cases from './pages/Cases';
import About from './pages/About';
import EmployeeDetail from './pages/EmployeeDetail';
import Contact from './pages/Contact';
import ErrorPage from './pages/ErrorPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-white antialiased">
        {/* Navigation Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Front Page */}
            <Route path="/" element={<Home />} />

            {/* Varmepumper (Undersider) */}
            <Route path="/varmepumper/:subpage" element={<PageDetail />} />

            {/* El-installation (Undersider) */}
            <Route path="/el-installation/:subpage" element={<PageDetail />} />

            {/* Sikring & Netværk (Undersider) */}
            <Route path="/sikring-og-netvaerk/:subpage" element={<PageDetail />} />

            {/* Cases & Referencer */}
            <Route path="/cases" element={<Cases />} />

            {/* Om os */}
            <Route path="/om-os" element={<About />} />
            <Route path="/om-os/medarbejder/:id" element={<EmployeeDetail />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<Contact />} />

            {/* Error Pages */}
            <Route path="/403" element={<ErrorPage type="403" />} />
            <Route path="*" element={<ErrorPage type="404" />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
